import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IResource, ResourceSchema } from '@lifk/types'
import { z } from 'zod'

export const transformSanityResources = (
  sanityResources: any[],
  disableValidations: boolean
): IResource[] => {
  const validation = z.array(ResourceSchema).safeParse(sanityResources)
  let resources: IResource[] = validation.data ?? []
  if (!validation.success) {
    resources = removeInvalidItems(
      sanityResources,
      validation.error,
      disableValidations
    )
  }
  return resources
}
